var map = {
	"./Aatrox.png": 50,
	"./Amumu.png": 51,
	"./Annie.png": 52,
	"./Ashe.png": 53,
	"./Azir.png": 54,
	"./Brand.png": 55,
	"./Braum.png": 56,
	"./Diana.png": 57,
	"./DrMundo.png": 58,
	"./Ivern.png": 59,
	"./Janna.png": 60,
	"./Jax.png": 61,
	"./Karma.png": 62,
	"./Khazix.png": 63,
	"./Kindred.png": 64,
	"./KogMaw.png": 65,
	"./LeBlanc.png": 66,
	"./Leona.png": 67,
	"./Lucian.png": 68,
	"./Malphite.png": 69,
	"./Malzahar.png": 70,
	"./Maokai.png": 71,
	"./MasterYi.png": 72,
	"./Nami.png": 73,
	"./Nasus.png": 74,
	"./Nautilus.png": 75,
	"./Neeko.png": 76,
	"./Nocturne.png": 77,
	"./Olaf.png": 78,
	"./Ornn.png": 79,
	"./RekSai.png": 80,
	"./Renekton.png": 81,
	"./Senna.png": 82,
	"./Singed.png": 83,
	"./Sion.png": 84,
	"./Sivir.png": 85,
	"./Skarner.png": 86,
	"./Soraka.png": 87,
	"./Syndra.png": 88,
	"./Taliyah.png": 89,
	"./Taric.png": 90,
	"./Thresh.png": 91,
	"./Twitch.png": 92,
	"./Varus.png": 93,
	"./Vayne.png": 94,
	"./Veigar.png": 95,
	"./Vladimir.png": 96,
	"./Volibear.png": 97,
	"./Warwick.png": 98,
	"./Yasuo.png": 99,
	"./Yorick.png": 100,
	"./Zed.png": 101,
	"./Zyra.png": 102
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49;